var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject } from 'aurelia-dependency-injection';
import { Exception } from '../models/Exception';
import { TokenService } from './TokenService';
import { SecurityContext } from './SecurityContext';
let TokenSecurityContextProvider = class TokenSecurityContextProvider {
    /**
     * TokenSecurityContextProvider constructor
     * @param tokenService service for verifying tokens (requires sso public keys in config passed to constructor)
     * @param securityContextFactory factory for creating custom security context (optional)
     */
    constructor(tokenService, securityContextFactory = { getInstance: (account, token, policy) => new SecurityContext(account, token, policy) }) {
        this.tokenService = tokenService;
        this.securityContextFactory = securityContextFactory;
    }
    /**
     * This entry point implements the interface required by express-router-adapter, plus the addition
     * of `allowAnonymous` to support lambda-based apps using `gatewayEventHandlerV2()` handlers.
     */
    getSecurityContext({ req, allowAnonymous }) {
        console.info('TokenSecurityContextProvider.getSecurityContext');
        try {
            const headers = req.headers;
            // assume header might not have been normalized
            const authHeaderValue = headers ? headers.authorization || headers.Authorization : undefined;
            if (!authHeaderValue && allowAnonymous) {
                // create anonymous user that will fail all security checks
                return this.securityContextFactory.getInstance(undefined, undefined, undefined);
            }
            if (!authHeaderValue) {
                throw new Error('Authorization header is required');
            }
            const accessToken = this.tokenService.stripBearer(authHeaderValue);
            const decodedTokenPayload = this.tokenService.decodePayload(accessToken);
            if (!decodedTokenPayload) {
                throw new Error('Unable to find payload in token');
            }
            const { account, policy } = this.tokenService.verify(accessToken);
            return this.securityContextFactory.getInstance(account, accessToken, policy);
        }
        catch (err) {
            throw new Exception(`Invalid authorization header: ${err.message}`, 401, err);
        }
    }
    /**
     * This entry point is intended for use in client-side apps, where a verified token is available.
     * IMPORTANT: This does NOT verify the token!!! The context returned should be used as a helper
     * for building a U/X configured for the user's permissions, but should not be considered to be
     * providing any kind of security.
     */
    getUnverifiedContext({ accessToken }) {
        console.info('TokenSecurityContextProvider.getSecurityContextFromToken');
        try {
            const decodedTokenPayload = this.tokenService.decodePayload(accessToken);
            if (!decodedTokenPayload) {
                throw new Error('Unable to find payload in token');
            }
            const { account, policy } = decodedTokenPayload;
            return this.securityContextFactory.getInstance(account, accessToken, policy);
        }
        catch (err) {
            throw new Exception(`Invalid authorization: ${err.message}`, 401, err);
        }
    }
};
TokenSecurityContextProvider = __decorate([
    autoinject,
    __metadata("design:paramtypes", [TokenService, Object])
], TokenSecurityContextProvider);
export { TokenSecurityContextProvider };
//# sourceMappingURL=TokenSecurityContextProvider.js.map